import { useEffect } from 'react';
import { useSolicitudCoberturaIniciadoAutorizadoData } from '../hooks/useSolicitudCoberturaIniciadoAutorizadoData';
import { IniciadoAutorizadoTotalesSection } from './IniciadoAutorizadoTotalesSection';
import { IniciadoAutorizadoSection } from './IniciadoAutorizadoSection';

const initData = {
  idDivision: 5,
  idTipoCobertura: 166,
};

export const SolicitudCoberturaIniciadoAutorizado = () => {
  const { getSolicitudCoberturaAnualList, getSolicitudCoberturaMensualList } =
    useSolicitudCoberturaIniciadoAutorizadoData({
      ...initData,
    });

  useEffect(() => {
    getSolicitudCoberturaAnualList();
    getSolicitudCoberturaMensualList();
  }, []);

  return (
    <>
      <IniciadoAutorizadoTotalesSection />
      <IniciadoAutorizadoSection />
    </>
  );
};
